/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { OrcidAuthorizeDTO } from './OrcidAuthorizeDTO';
import {
    OrcidAuthorizeDTOFromJSON,
    OrcidAuthorizeDTOFromJSONTyped,
    OrcidAuthorizeDTOToJSON,
    OrcidAuthorizeDTOToJSONTyped,
} from './OrcidAuthorizeDTO';
import type { RoleDTO } from './RoleDTO';
import {
    RoleDTOFromJSON,
    RoleDTOFromJSONTyped,
    RoleDTOToJSON,
    RoleDTOToJSONTyped,
} from './RoleDTO';

/**
 * 
 * @export
 * @interface UsersDTO
 */
export interface UsersDTO  {
    /**
     * 
     * @type {number}
     * @memberof UsersDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UsersDTO
     */
    givenname?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersDTO
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersDTO
     */
    surname?: string;
    /**
     * 
     * @type {number}
     * @memberof UsersDTO
     */
    type?: number;
    /**
     * 
     * @type {string}
     * @memberof UsersDTO
     */
    username?: string;
    /**
     * 
     * @type {number}
     * @memberof UsersDTO
     */
    personId?: number;
    /**
     * 
     * @type {RoleDTO}
     * @memberof UsersDTO
     */
    role?: RoleDTO;
    /**
     * 
     * @type {OrcidAuthorizeDTO}
     * @memberof UsersDTO
     */
    orcidAuthorize?: OrcidAuthorizeDTO;
}

/**
 * Check if a given object implements the UsersDTO interface.
 */
export function instanceOfUsersDTO(value: object): value is UsersDTO {
    return true;
}

export function UsersDTOFromJSON(json: any): UsersDTO {
    return UsersDTOFromJSONTyped(json, false);
}

export function UsersDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'givenname': json['givenname'] == null ? undefined : json['givenname'],
                  'password': json['password'] == null ? undefined : json['password'],
                  'surname': json['surname'] == null ? undefined : json['surname'],
                  'type': json['type'] == null ? undefined : json['type'],
                  'username': json['username'] == null ? undefined : json['username'],
                  'personId': json['personId'] == null ? undefined : json['personId'],
                  'role': json['role'] == null ? undefined : RoleDTOFromJSON(json['role']),
                  'orcidAuthorize': json['orcidAuthorize'] == null ? undefined : OrcidAuthorizeDTOFromJSON(json['orcidAuthorize']),
    };
}

export function UsersDTOToJSON(json: any): UsersDTO {
    return UsersDTOToJSONTyped(json, false);
}

export function UsersDTOToJSONTyped(value?: UsersDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'givenname': value['givenname'],
        'password': value['password'],
        'surname': value['surname'],
        'type': value['type'],
        'username': value['username'],
        'personId': value['personId'],
        'role': RoleDTOToJSON(value['role']),
        'orcidAuthorize': OrcidAuthorizeDTOToJSON(value['orcidAuthorize']),
    };
}


